import { render, staticRenderFns } from "./RipaBeatsGrid.vue?vue&type=template&id=54447778"
import script from "./RipaBeatsGrid.vue?vue&type=script&lang=js"
export * from "./RipaBeatsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports